import { Component, Input, OnInit } from '@angular/core';
import { Camera, CameraResultType } from '@capacitor/camera';
import { ActionSheetController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { ProductPayload } from 'src/app/stores/seller-product.store';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
})
export class VideoModalComponent implements OnInit {
  @Input() video: { full: string };
  @Input() editOption: boolean;
  @Input() product: ProductPayload;
  image: string;
  base64String: string
  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private actionSheetCtrl: ActionSheetController,
    private loaderService: LoaderService,
    private auth: AuthenticationStore
  ) { }

  ngOnInit() {
  }
  dismiss() {
    this.modalCtrl.dismiss();
  }

  async editOtions() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('OWN_SHOP.EDIT_DELETE_IMAGE'),
      subHeader: '',
      buttons: [
        {
          text: this.translate.instant('OWN_SHOP.EDIT_IMAGE'),
          icon: 'create-outline',
          handler: async () => {
            const image = await Camera.getPhoto({
              quality: 50,
              allowEditing: true,
              resultType: CameraResultType.DataUrl,
            });
            this.image = image.dataUrl;
            this.loaderService.showLoading();

            try {
              const imageUrl: any = await this.auth.imageUpload(
                image.dataUrl
              );
              this.loaderService.dismissLoading();
              this.product.video_thumbnail = imageUrl.data.name;
              this.dismiss()
            } catch (error) {
              this.dismiss()
              this.loaderService.dismissLoading();
              this.loaderService.presentToast(
                error.error.data
                  ? error.error.data
                  : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
                'bottom',
                'danger'
              );
            }
          },
        },
        {
          text: this.translate.instant('OWN_SHOP.EDIT_VIDEO'),
          icon: 'create-outline',
          handler: async () => {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'video/*';
            fileInput.addEventListener('change', async (event) => {
              this.uploadVideo(event);
            });
            fileInput.click();
          },
        },
        {
          text: this.translate.instant('OWN_SHOP.DELETE_IMAGE_VIDEO'),
          icon: 'trash-outline',
          handler: async () => {
            this.dismiss()
            this.product.video_thumbnail = null
            this.product.video_full = null
            this.video.full = null
          },
        },
      ],
    });
    await actionSheet.present();
  }


  async uploadVideo(event) {
    const file = event.target.files[0];
    const reader: any = await new FileReader();
    reader.onloadend = async () => {
      this.base64String = await reader.result
      this.loaderService.showLoading();
      if (this.base64String) {
        try {
          const videoPath: any = await this.auth.videoUpload({ file_name: this.base64String });
          this.loaderService.dismissLoading();
          this.product.video_full = videoPath.data.full_path
          this.video.full = videoPath.data.full_path
          this.dismiss()
        } catch (error) {
          this.dismiss()
          this.loaderService.dismissLoading();
          this.loaderService.presentToast(error.error.data
            ? error.error.data
            : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'), 'bottom', 'danger');
        }
      }
    };
    await reader.readAsDataURL(file);
  }

}
